// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"8220b387","513":"477d7ff6"}[chunkId] + ".chunk.js";
};